import React, { useState } from 'react';
import { Upload, message, Spin, Modal } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { CountDetailsInterface } from './Interfaces';

type FileUploaderProps = {
    uploadUrl: string;
    btnName: string;
    setCountsDetails: any;
    setCountsDetailsSearch: any;
    countsDetails: any;
    countsDetailsSearch: any;
};

const FileUploader: React.FC<FileUploaderProps> = ({ uploadUrl, btnName, setCountsDetails, setCountsDetailsSearch, countsDetails, countsDetailsSearch }) => {
    const { t, i18n } = useTranslation('common');
    const currentLanguage = i18n.language

    const [uploading, setUploading] = useState<boolean>(false);

    const getToken = () => {
        return localStorage.getItem('accessToken');
    };

    const handleUpload = async (file: File) => {
        setUploading(true);

        const formData = new FormData();
        formData.append('file', file);

        try {
            const { data } = await axios.post(uploadUrl, formData, {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            setCountsDetails(countsDetails.map((item: CountDetailsInterface) => {
                const found = data.data.find((c: CountDetailsInterface) => c.item.id === item.item.id)
                if (item.item.id === found.item.id) {
                    const { message, ...updatedItem } = found;
                    return updatedItem;
                }
                return item;
            }));
            setCountsDetailsSearch(countsDetailsSearch.map((item: CountDetailsInterface) => {
                const found = data.data.find((c: CountDetailsInterface) => c.item.id === item.item.id)
                if (item.item.id === found.item.id) {
                    const { message, ...updatedItem } = found;
                    return updatedItem;
                }
                return item;
            }));
            message.success('File uploaded successfully');
        } catch (error) {
            console.error('Error uploading file:', error);
            message.error('Error uploading file');
        } finally {
            setUploading(false);
        }
    };

    const customRequest = ({ file, onSuccess, onError }: any) => {
        setTimeout(() => {
            handleUpload(file);
            onSuccess();
        }, 0);
    };

    return (
        <>
            <Upload customRequest={customRequest} showUploadList={false}>
                <div onClick={() => { }}>
                    <UploadOutlined
                        style={{
                            color: '#1677FF',
                            fontSize: '20px',
                            marginRight: currentLanguage == 'ar' ? '0px' : '15px',
                            marginLeft: currentLanguage == 'ar' ? '15px' : '0px'
                        }} />
                    {btnName}
                </div>
            </Upload>
            <Modal visible={uploading} title={t('uploading-file')} footer={null} closable={false} centered bodyStyle={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Spin size="large" />
            </Modal>
        </>
    );
};

export default FileUploader;
